import styles from '../AvatarInput.module.scss';

interface ZoomControlProps {
  scale: number;
  maxScale: number;
  onScaleChange: (scale: number) => void;
}

export function ZoomControl(props: ZoomControlProps) {
  const { scale, maxScale, onScaleChange } = props;

  if (maxScale <= 1) {
    return null;
  }

  return (
    <div className={styles.zoomControl}>
      <span>Zoom:</span>
      <input
        type="range"
        min="1"
        max={maxScale}
        step="0.01"
        value={scale}
        onChange={(e) => onScaleChange(parseFloat(e.target.value))}
        className={styles.zoomSlider}
      />
    </div>
  );
}
